import { jsx as _jsx } from "react/jsx-runtime";
import Preloader from '../../assets/preloader.svg';
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
const ButtonSubmit = (props) => {
    const { isSubmitting, signIn, clearErrors } = props;
    const { t } = useTypedTranslation();
    function defineTypeButton(type) {
        if (type.signIn)
            return t('signIn');
        if (type.signUp)
            return t('registration');
        return t('createChannel');
    }
    const clearDataError = () => {
        if (signIn)
            clearErrors('dataError');
    };
    return (_jsx("div", { children: _jsx("button", { style: { width: '100%' }, onClick: clearDataError, disabled: isSubmitting, children: isSubmitting ? _jsx(Preloader, {}) : defineTypeButton(props) }) }));
};
export default ButtonSubmit;
